<template>

    <section id="cotizacion">
  <div class="row">
    <GmapMap
  :center="{lat:10, lng:10}"
  :zoom="7"
  map-type-id="terrain"
  style="width: 500px; height: 300px"
>
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    @click="center=m.position"
  />
</GmapMap>
  </div>
</section>


</template>


<script>

export default {
  name: "TwoModules",
  data() {
    return {
     
    };
  },
  methods: {

  //manadatory function called from cardTemplate 
    
  created() {
    
  }
}
}
</script>

<style>
.best-products {
  margin-bottom: 10px;
}
</style>
